import { memo } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
// Local files
import logo from 'assets/images/logo.svg';
import Form from 'components/Authentication/Form/Form';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';

const Authentication = () => {
  const { pathname, state } = useLocation();

  if (pathname === '/sign_up' && !!!state?.invitation_token) return <Navigate to='/sign_in' replace />;

  return (
    <Box sx={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', bgcolor: 'background.paper' }}>
      <Container maxWidth='xs'>
        <img src={logo} alt='logo' style={{ display: 'block', userSelect: 'none', width: '100%', maxWidth: 260, height: 'auto', margin: '0 auto 24px' }} />
        <Form />
      </Container>
    </Box>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <Authentication {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);